<template>
    <div>
        <el-dialog
            class="choose-medical"
            :visible.sync="show"
            title="选择医案库"
            width="450px"
            :before-close="handleClose"
            >
            <el-form class="form-data">
                <el-form-item label="请选择医案库："  label-width="120px">
                    <el-select 
                            
                            v-model="chooseStoreId" 
                            placeholder="请选择" >
                        <el-option
                            v-for="(item, index) in librarylistoptions"
                            :key="index"
                            :label="item.storeName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="new_medical()" type="primary" plain>新建医案库</el-button >
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="saveLibraryList()" type="primary" >确定</el-button >
            </span>
        </el-dialog>
        <newMedical :show.sync='isNewMedical'></newMedical>
    </div>
    
</template>

<script>

import { mapState,mapMutations } from "vuex";
import newMedical from '../ui-kit/new_medical.vue' 
export default {
    props: ['show',],
    components: {
        newMedical,
    },
    data () {
        return {
            chooseStoreId:'',
            isNewMedical:false
            // librarylistoptions:[],

        }
    },
    computed: {
      ...mapState(['librarylistoptions'])  
    },
    mounted () {
        // this.getList();  
    },
    methods: { 
        saveLibraryList(){
            if(this.chooseStoreId==''){
                this.$message.error("请选择医案库！");
                return
            }else{
                this.$emit('save',this.chooseStoreId);
                this.chooseStoreId='';
            }
            
        },
        new_medical(){
            this.isNewMedical = true;
        },
        handleClose(){
            this.$emit('update:show',false);
            this.chooseStoreId='';
            // this.initData();
        },
    }
}
</script>

<style lang='less' scoped>
.choose-medical /deep/.el-dialog__header{
    line-height: 24px;
    background-color: #409EFF ;
    font-size: 18px;
    padding: 10px 20px;
}
.choose-medical /deep/ .el-dialog__title{
    color: #fff;
}
    
.choose-medical /deep/ .el-dialog__header{
    line-height: 24px;
    background-color: #409EFF ;
    font-size: 18px;
    padding: 10px 20px;
    .el-dialog__title{
        color: #fff;
    }
    
}
    
.choose-medical /deep/  .el-dialog__headerbtn{
    top: 12px;
}
.choose-medical /deep/  .el-dialog__close,.el-dialog__headerbtn{
    color: #fff !important;
    // &:hover{
    //      color: #fff;
    // }
}
 
.choose-medical /deep/  .el-dialog__body{
    padding: 20px 20px 2px;
}
.choose-medical /deep/  .el-dialog__footer{
    padding-top: 0;
    display: flex;
    justify-content: space-between;
    // background-color: rgba(250, 243, 229, 0.8) !important;
}



</style>